import { primaryColor } from "../../../data-service/backend-functions/helpers";
import one from "../../../images/icon/one.svg";
import three from "../../../images/icon/three.svg";
import two from "../../../images/icon/two.svg";
import { Card } from "../card";

const conferencesAdvantages = [
  {
    icon: one,
    title: "Create Virtual Zone",
    text: "Geofencing leverages precise latitude and longitude coordinates to create a virtual “fence” around specific conference venues (such as convention center and hotels).",
  },
  {
    icon: two,
    title: "Capture Mobile ID",
    text: "When an attendee enters this virtual zone with their mobile device, their mobile ID is captured — in accordance with GPS, GPC, and privacy preferences.",
  },
  {
    icon: three,
    title: "Deliver Targeted Ads",
    text: "Geofencing continues for 30 days after the event, delivering cross-device ads to all attendee devices — not just the one that crossed the virtual fence.",
  },
];

export const Conferences = () => {
  return (
    <section className="section-sp2">
      <div
        className="container inner-content"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h2>Target HCP’s Attending Conferences </h2>
        <p className="text-center">
          Conference marketing can quickly become very costly, and measuring its
          success is often <br /> challenging. However, there is a powerful
          digital strategy that helps you reach and engage your HCP <br />{" "}
          audience attending specific conferences: Conference Geofencing.
        </p>
        <h5 style={{ color: primaryColor }}>How It Works</h5>
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            gap: "30px",
          }}
          className="advantages"
        >
          {conferencesAdvantages.map((advantage) => (
            <Card
              icon={advantage.icon}
              title={advantage.title}
              text={advantage.text}
              minHeight="400px"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
